const pad = (n: number, width = 2): string =>
    String(Math.abs(Math.trunc(n))).padStart(width, "0");

/** Минуты К ВОСТОКУ от UTC (Москва = 180), в отличие от getTimezoneOffset. */
export const tzOffsetMin = (d: Date = new Date()): number => {
    const v = -d.getTimezoneOffset();
    return v === 0 ? 0 : v; // в UTC здесь −0: JSON напишет 0, а Object.is — нет
};

export const formatOffset = (minutesEast: number): string => {
    const sign = minutesEast >= 0 ? "+" : "-";
    const a = Math.abs(minutesEast);
    return `${sign}${pad(Math.floor(a / 60))}:${pad(a % 60)}`;
};

/**
 * Местное время со смещением: "2026-09-23T14:05:03.123+03:00".
 * Собирается руками: toISOString даёт только UTC, а Intl не отдаёт миллисекунды
 * и смещение одной строкой во всех браузерах.
 */
export const toLocalIso = (d: Date): string =>
    `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}` +
    `.${pad(d.getMilliseconds(), 3)}${formatOffset(tzOffsetMin(d))}`;

export const timeZone = (): string => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch {
        return "";
    }
};

export const perfNow = (): number => {
    try {
        return Math.round(performance.now() * 10) / 10;
    } catch {
        return 0;
    }
};
